import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import { Title } from './Login.styles';

const LoginContextError = () => {
  const { t } = useTranslation();

  return (
    <Row className="justify-content-center width-full">
      <Col sm={8} md={8} lg={7} xl={5}>
        <Title data-testid="login-context-error-title">
          {t('pageLogin.contextErrorTitle')}
        </Title>
        <p data-testid="login-context-error-body">
          {t('pageLogin.contextErrorBody')}
        </p>
      </Col>
    </Row>
  );
};

export default LoginContextError;
